export default {
      id: "file-type-spreadsheet-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#file-type-spreadsheet",
      toString: function () {
        return this.url;
      }
    }